/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Device} from '@ion/core/src/types/entities';
import Chip from '@ion/dls/src/components/chip/Chip';
import {useDeviceName} from '@ion/dls/src/hooks/useDeviceName';
import {MaterialExitCloseIcon} from '@ion/dls/src/icons/MaterialExitCloseIcon';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {IconSize} from '@ion/dls/src/types/types';

// defines the prop definitions for Device chips editor ...
export interface DeviceChipProps {
  classes: string;
  device: Device;
  isDelete: boolean;
  onDelete: (device: Device) => void;
};

export const DeviceChip = ({device, isDelete, classes, onDelete}: DeviceChipProps) => {
  const name = useDeviceName(device, true);

  return (
    <div className={classes}>
      <Chip label={name}
        customDeleteIcon={isDelete ? <MaterialExitCloseIcon size={IconSize.small} /> : undefined}
        onDelete={isDelete ? onDelete(device) : undefined}
        labelColor={dlsColor('grey2')}
        borderRadius='56px'
        size='small'
        maxWidth={false}
        hoverDefault
        showCustomDeleteIcon
        noTextTransform />
    </div>
  );
};
export default DeviceChip;
